/* eslint-disable no-restricted-globals */
import axios from "axios";
import { isExpired } from "react-jwt";
import config from "../config";
import { authenticationService } from "../services/authentication.service";
import Auth from "../utils/auth";

const {
  apiGateway: { URL, directory },
} = config;
// const location = useLocation();

const httpClient = axios.create({
  baseURL: URL,
  withCredentials: true,
  timeout: 300000,
});

httpClient.interceptors.request.use((config) => {
  const queryParams = new URLSearchParams(window.location.search);
  const stateParam = queryParams.get("state") || "";
  const TOKEN = Auth.getToken();
  const TOKENS = stateParam && stateParam ==='openWithOwner' ? Auth.getProxyToken() : Auth.getToken();

  if (TOKEN) {
    const isMyTOKENExpired = isExpired(TOKEN);
    if (isMyTOKENExpired) {
      authenticationService.logout();
      window.location = '/'
    }
    config.headers["x-access-token"] = `${TOKENS}`;
  } else {
    config.withCredentials = false
  }
  return config;
});

//add 401 based on root if possible
httpClient.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response.status == 403) {
      window.location = "/unauthorized"
    } else if (err.response.status == 401) {
      authenticationService.logout();
      if (location.pathname != "/") {
        window.location = '/';
      }
    }
    // if ([401, 403].indexOf(err.response?.status) !== -1) {
    //   // authenticationService.logout();
    //   // if (location.pathname != "/") {
    //   //   window.location = `${directory}`;
    //   // }
    // }
    const error = (err.response && err.response.data.message) || err.message;
    if (axios.isCancel(err)) {
      return Promise.resolve(err.message);
    } else {
      return Promise.reject(error);
    }
  }
);

export default httpClient;
